import icon from 'assets/icons/pie-icon.svg';
import React, {Component, PureComponent} from 'react';
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import './ToiOpexBranch.style.scss';

export default class ToiOpexBranch extends Component {
  render() {
    const data = [
      {
        branch: 'HA NOI',
        TOI: 280,
        OPEX: 56,
        'OPEX/TOI': 20,
        'PROFIT AFTER COST ALLOCATION': 222.88,
      },
      {
        branch: 'HO CHI MINH',
        TOI: 100,
        OPEX: 21,
        'OPEX/TOI': 21,
        'PROFIT AFTER COST ALLOCATION': 78.58,
      },
      {
        branch: 'BAC NINH',
        TOI: 160,
        OPEX: 35.2,
        'OPEX/TOI': 22,
        'PROFIT AFTER COST ALLOCATION': 124.096,
      },
      {
        branch: 'THAI NGUYEN',
        TOI: 80,
        OPEX: 20,
        'OPEX/TOI': 25,
        'PROFIT AFTER COST ALLOCATION': 59.6,
      },
      {
        branch: 'HAI PHONG',
        TOI: 280,
        OPEX: 50.4,
        'OPEX/TOI': 18,
        'PROFIT AFTER COST ALLOCATION': 228.592,
      },
      {
        branch: 'BINH DUONG',
        TOI: 100,
        OPEX: 17,
        'OPEX/TOI': 17,
        'PROFIT AFTER COST ALLOCATION': 82.66,
      },
      {
        branch: 'DONG NAI',
        TOI: 160,
        OPEX: 32,
        'OPEX/TOI': 20,
        'PROFIT AFTER COST ALLOCATION': 127.36,
      },
      {branch: 'HA NAM', TOI: 80, OPEX: 20, 'OPEX/TOI': 25, 'PROFIT AFTER COST ALLOCATION': 59.6},
      {
        branch: 'DA NANG',
        TOI: 280,
        OPEX: 50.4,
        'OPEX/TOI': 18,
        'PROFIT AFTER COST ALLOCATION': 228.592,
      },
      {
        branch: 'BIEN HOA',
        TOI: 100,
        OPEX: 17,
        'OPEX/TOI': 17,
        'PROFIT AFTER COST ALLOCATION': 82.66,
      },
      {
        branch: 'SAI GON',
        TOI: 160,
        OPEX: 40,
        'OPEX/TOI': 25,
        'PROFIT AFTER COST ALLOCATION': 119.2,
      },
      {
        branch: 'VINH PHUC',
        TOI: 80,
        OPEX: 14.4,
        'OPEX/TOI': 18,
        'PROFIT AFTER COST ALLOCATION': 65.312,
      },
      {
        branch: 'HOAN KIEM',
        TOI: 100,
        OPEX: 17,
        'OPEX/TOI': 17,
        'PROFIT AFTER COST ALLOCATION': 82.66,
      },
      {
        branch: 'PHU MY HUNG',
        TOI: 160,
        OPEX: 24,
        'OPEX/TOI': 15,
        'PROFIT AFTER COST ALLOCATION': 135.52,
      },
    ];

    return (
      <div className='ToiOpexBranchcontainer'>
        <h1 className='ToiOpexBranchtitle'>
          <img src={icon} alt='' style={{marginRight: 8}} />
          TOI AND OPEX by BRANCH
        </h1>
        <ResponsiveContainer width='100%' height={300}>
          <ComposedChart height={300} data={data}>
            <XAxis
              dataKey='branch'
              axisLine={false}
              tickLine={false}
              tick={<CustomizedAxisTick />}
            />
            <YAxis yAxisId={1} axisLine={false} tickLine={false} />
            <YAxis yAxisId={2} hide domain={[0, 100]} />
            <CartesianGrid yAxis={{hide: true}} />
            <Bar yAxisId={1} dataKey='TOI' barSize={50} fill='#FDE39B' radius={8} />
            <Bar yAxisId={1} dataKey='OPEX' barSize={50} fill='#EBEBEB' radius={8} />
            <Bar
              yAxisId={1}
              dataKey='PROFIT AFTER COST ALLOCATION'
              barSize={50}
              fill='#C89404'
              radius={8}
            />
            <Line yAxisId={2} dataKey='OPEX/TOI' stroke='#C50F2F' strokeWidth={2} />
            <Legend
              wrapperStyle={{
                paddingTop: '20px',
              }}
            />
            <Tooltip cursor={false} content={<CustomTooltip />} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

class CustomizedAxisTick extends PureComponent {
  render() {
    const {x, y, payload} = this.props;

    return (
      <text x={x} y={y} dy={24} fill='#0B0B0A' textAnchor='middle' fontSize={14}>
        <tspan>{payload.value}</tspan>
      </text>
    );
  }
}

const CustomTooltip = (props) => {
  const {active, payload} = props;

  if (active && payload && payload.length) {
    const item = payload[0].payload;

    return (
      <div className='custom-tooltip'>
        <div className='name'>{item.branch}</div>
        <div className='item'>
          <div className='color' style={{backgroundColor: '#FDE39B'}} />
          <div className='desc'>{item.TOI}</div>
        </div>
        <div className='item'>
          <div className='color' style={{backgroundColor: '#EBEBEB'}} />
          <div className='desc'>{item.OPEX}</div>
        </div>
        <div className='item'>
          <div className='color' style={{backgroundColor: '#C89404'}} />
          <div className='desc'>{item['PROFIT AFTER COST ALLOCATION']}</div>
        </div>
        <div className='item'>
          <div className='color' style={{backgroundColor: '#C50F2F'}} />
          <div className='desc'>{item['OPEX/TOI']}%</div>
        </div>
      </div>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewByBranch/components/ToiOpexBranch/ToiOpexBranch.js